import React,{useContext,useEffect,useState} from "react";
import CrossIcon from "../../../../components/navbar/nav-icons/CrossIcon";
import AddReportIcon from "../../../../components/SVGComponents/AddReportIcon";
import SuggestTickIcon from "../../../../components/SVGComponents/SuggestTickIcon";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import ContextMenuTemplate from "../ContextMenuTemplate/ContextMenuTemplate"
import DBadge from "../../../../components/SVGComponents/DBadge";
import RBadge from "../../../../components/SVGComponents/RBadge";
import PBadge from "../../../../components/SVGComponents/PBadge";
import { REPORT_TITLE, USERTYPES } from "../../../../constants/Constants";
import CLBadge from "../../../../components/SVGComponents/CLBadge";
import ConfirmModal from "../ReportModals/ConfirmationModal";
import { useTranslation } from "react-i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import LBadge from "../../../../components/SVGComponents/LBadge";
import ModalMain from "../../../../components/Modal/ModalMain";
import { isMobile } from "react-device-detect";
import { getEnv } from '../../../../helpers/EnvHelper';

const AddTab = (props) => {

  const [t, i18n] = useTranslation();

  const { getThemeColor,themeName } = useContext(themeContext);

  const { patientReports,childPatientReports, handleRemoveTemplate, handleChangeTemplate, handleChildChangeTemplate, suggestedListReport, studyReportPdf, studyReportPdfSelected
  ,handleDropdownWithContext,allReportTemplates,isClientReportExist,hasUnsavedChanges,isWordFilePath, confirmMultipleTemplateOpen, confirmMultipleTemplateModalContent, disableEditReport ,isexternalStudyReport, userRole} =
    useContext(studyReportContext);

  const patientReportsUpdated = props.isChild ? childPatientReports : patientReports;
  const showStudyReportPdf =!props.isChild && isexternalStudyReport;
  const studyReportPdfTabStyle = {
    background: getThemeColor(
      studyReportPdfSelected ? "report-active-tab" : "report-not-active-tab"
    ),
    color: getThemeColor("alter-primary-color"),
  };
  
  const [dtReportTemplatesId,setDtReportTemplatesId] = useState([]);
  const [rsnaReportTemplateId,setRsnaReportTemplatesId] = useState([]);
  const [radioReportTemplateId,setRadioReportTemplatesId] = useState([]);
  const [dsrReportTemplateId, setDsrReportTemplateId] = useState([]);

  const [confirmationModalData,setConfirmationModalData] = useState({
    event: null,
    index: null,
    key: null,
    show: false
  });

  useEffect(()=>{
    let dtOpt = [];
    let rsnaOpt = [];
    let radiologistOpt = [];
    let dsrOpt = [];
    if(Object.keys(allReportTemplates).length > 0){
      allReportTemplates.reportTemplates?.map((ele) => {

        dtOpt.push(ele.id);
      });
      allReportTemplates.rsnaReportTemplates?.map((ele) => {
        if(ele.title == "TUBERCULOSIS"){
          rsnaOpt.push(ele.id);
        }else
        rsnaOpt.push(ele.id);
      });
      allReportTemplates.radiologistReportTemplates?.map((ele) => {
        radiologistOpt.push(ele.id);
      });
      allReportTemplates.dsrReportTemplates?.map((ele) => {
        dsrOpt.push(ele.id);
      })

      
      setDtReportTemplatesId(dtOpt);
      setRsnaReportTemplatesId(rsnaOpt);
      setRadioReportTemplatesId(radiologistOpt);
      setDsrReportTemplateId(dsrOpt);
    }
  },[allReportTemplates])
  //useEffect for highlighting tab
  useEffect(() => {
  if (
    patientReportsUpdated.length > 0 &&
    // nothing is selected yet
    !patientReportsUpdated.some(r => r.selected) 
  ) {
    // Setting the first report as selected
    handleChangeTemplate(patientReportsUpdated[patientReportsUpdated.length - 1]);
  }
}, [patientReportsUpdated]);

  const [showAddContext, setShowAddContext] = useState(false);

  // useEffect(()=>{
    
  //   if(rsnaReportTemplateId.length > 0){
  //     console.log("Dt admin");
  //     console.log(allReportTemplates);
  //     console.log(patientReports);
  //     console.log(rsnaReportTemplateId);
  //   }
  // },[rsnaReportTemplateId]);

  const subStr = (str)=>{
    // console.log("subStr");
    // console.log(str.substr(0,str.length-3));
    return str.substr(0,str.length-3);
  }
  // style={{height:patientReports.length == 0 ? "33px":'unset'}}

  const handleConfirmation = (e,key,index) => {
    setConfirmationModalData(()=>{
      const newItem = {...confirmationModalData};
      newItem.event = e;
      newItem.key = key;
      newItem.index = index;
      newItem.show = true;
      return newItem
    });
  }

  const hideModal = () => {
    setConfirmationModalData(()=>{
      const newItem = {...confirmationModalData};
      newItem.event = null;
      newItem.key = null;
      newItem.index = null;
      newItem.show = false;
      return newItem
    });
  }

  const getRadiologistTemplateId = (reportData) => {
    if(reportData?.reportTemplateId == null || reportData?.reportTemplateId == undefined){
      return reportData?.id;
    }else{
      return reportData?.reportTemplateId;
    }
  }


  return (
    <>
      <div className="table-report">
        {confirmationModalData.show &&
          <ConfirmModal 
              data = {confirmationModalData}
              isModalOpen = {confirmationModalData.show}
              description = {t("string-literals.confirmation-delete")}
              hideModal = {hideModal}
              heading = "Alert"
              handleRemoveTemplate = {handleRemoveTemplate}
          />
        }
        <ul id="horizontal-list" >
          {showStudyReportPdf && (
            <li
                onClick={() => {
                  handleChangeTemplate(null);
                }}
                key="pdf-tab"
                style={studyReportPdfTabStyle}
                className={
                  studyReportPdfSelected ? `${props.isStudyList ? themeName+"-active-li":"active-li"} li-tab` : `${props.isStudyList ? themeName+"-tab":""} li-tab`
                }
              >
                <span style={{color:getThemeColor("alter-primary-color")}}>{(studyReportPdf?.aiPacsNodeName || "PDF") + " REPORT"}</span>
          
              </li>
          )}
          {patientReportsUpdated.map((report, index) => {
            return (
              <li
                onClick={() => {
                  if(props.isChild){
                    handleChildChangeTemplate(report);
                    return;
                  }
                  handleChangeTemplate(report);
                }}
                id={report.text}
                key={index}
                //style={{background: props.isStudyList ? getThemeColor('report-not-active-tab') : "#1E1E1E"}}
                style={{background:  getThemeColor('report-not-active-tab'),color:getThemeColor("alter-primary-color")}}
                className={
                  !studyReportPdfSelected && report.isSuperSpecialReport ? `${props.isStudyList ? themeName+"-active-li":"active-li"} li-tab` : `${props.isStudyList ? themeName+"-tab":""} li-tab`
                }
              >
                <span style={{color:getThemeColor("alter-primary-color")}}>{report.text}</span>
                <span className="badge-icon-d">
                 {report.text.includes(REPORT_TITLE.TUBERCULOSIS) && getEnv("REACT_APP_VDC_PLATFORM") == "false"?<RBadge/>: radioReportTemplateId.includes(getRadiologistTemplateId(report.reportDetails))?<PBadge/>:
                  dtReportTemplatesId.includes(report.reportDetails?.reportTemplateId)?<DBadge/>:
                  rsnaReportTemplateId.includes(report.reportDetails?.reportTemplateId) && getEnv("REACT_APP_VDC_PLATFORM") == "false"?<RBadge/>:
                  isClientReportExist?<CLBadge/>: dsrReportTemplateId.includes(report.reportDetails?.reportTemplateId) || dsrReportTemplateId.includes(report.reportDetails?.id)? <LBadge/> : <DBadge/>
                 }
                </span>
                {!props.isChild && userRole != USERTYPES.FIRMADMIN && (
                  <span
                  onClick={(e) => {
                    hasUnsavedChanges ? handleConfirmation(e,report.text,index) : handleRemoveTemplate(e, report.text, index);
                  }}
                  className="cross-icon"
                >
                  <CrossIcon />
                </span>)}
          
              </li>
            );
          })}
          {studyReportPdf && studyReportPdf.isAttached === true && ( 
            <li
                onClick={() => {
                  handleChangeTemplate(null);
                }}
                key="pdf-tab"
                style={{background:  getThemeColor('report-not-active-tab'),color:getThemeColor("alter-primary-color")}}
                className={
                  studyReportPdfSelected ? `${props.isStudyList ? themeName+"-active-li":"active-li"} li-tab` : `${props.isStudyList ? themeName+"-tab":""} li-tab`
                }
              >
                <span style={{color:getThemeColor("alter-primary-color")}}>{(studyReportPdf?.aiPacsNodeName || "PDF") + " REPORT"}</span>
          
              </li>
          )}
          {!props.isChild && !isWordFilePath && !disableEditReport && userRole != USERTYPES.FIRMADMIN && ( <li
            key="add"
            className="add-tab"
            style={{cursor:props.isChild ? "not-allowed" : "pointer",
                pointerEvents: props.isChild ? "none" : "unset"
          }}
            onClick={() => {
              if (showAddContext) {
                //setShowAddContext(false);
              } else {
                setShowAddContext(true);
              }
            }}
          >
            <AddReportIcon active={showAddContext} />
            <ContextMenuTemplate
              show={showAddContext}
              onClickOutside={() => {
                setShowAddContext(false);
              }}
              showAddContext={showAddContext}
              setShowAddContext = {setShowAddContext}
            />
          </li>)}
          {/* {patientReports.length == 0 && (
            <ul className="suggested-list">
              <li key="suggest-text" className="suggested-section">
                Suggested:
              </li>
              {suggestedListReport.map((report,index) => {
                return (
                  <li key={index} className="suggested-item">
                    <div className="suggested-div">
                      {report.text}
                      <span className="suggest-badge">
                        <DBadge />
                      </span>
                      <span
                        className="suggest-tick-icon"
                        style={{ cursor: "pointer" }}
                        onClick={()=>handleDropdownWithContext(report)}
                      >
                        <SuggestTickIcon />
                      </span>
                    </div>
                  </li>
                );
              })}
            </ul>
          )} */}
        </ul>
      </div>
      {confirmMultipleTemplateOpen &&
      <ModalMain
        updatedModal={true}
        modalDetails={confirmMultipleTemplateModalContent}
        showModal={true}
      />
      }
    </>
  );
};

export default AddTab;

export const CheckBadge = (id)=>{

}
